import mutations from './mutations';
var state = function state() {
  return {
    orderFormId: null
  };
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations
};